import type { IconName } from '@fortawesome/fontawesome-svg-core';

export const TaskPriorityMap: Record<string, { icon: IconName; text: string }> =
  {
    1: { icon: 'chevrons-down', text: 'Lowest' },
    2: { icon: 'chevron-down', text: 'Low' },
    3: { icon: 'grip-lines', text: 'Medium' },
    4: { icon: 'chevron-up', text: 'High' },
    5: { icon: 'chevrons-up', text: 'Highest' },
  };
